import { Grid, Typography } from "@mui/material";
import GenericDialog from "../components/shared/GenericDialog";

interface LandingModalProps {
    open: boolean;
    onClose: () => void;
    modalText: string;
    modalTitle: string;
    buttonText: string;
}

const LandingErrorModal: React.FC<LandingModalProps> = ({ open, onClose, modalText, modalTitle, buttonText }) => {

    return (
        <GenericDialog
            open={open}
            onClose={onClose}
            title={modalTitle}
            cancelButtonText={buttonText}
        >
            <Grid item>
                <Typography variant="h5">
                    {modalText}
                </Typography>
            </Grid>
        </GenericDialog>
    )
}

export default LandingErrorModal;